import React, { useCallback, useEffect, useRef, useState } from "react";
import uncodedIcon from "../../../common/assets/images/uncoded.png";
import unassignedIcon from "../../../common/assets/images/unassigned.png";
import overDueIcon from "../../../common/assets/images/overdue.png";
import inprogressIcon from "../../../common/assets/images/inprogress.png";
import backIcon from "../../../common/assets/images/back-icon.png";
import userIcon from "../../../common/assets/images/user-icon.png";
import generalsurgeryIcon from "../../../common/assets/images/general-surgery-icon.png";
import workflowFilterIcon from "../../../common/assets/images/workflow-filter-icon.png";
import LdsRoller from "../../../utils/LdsRoller";
import { Tooltip } from "@mui/material";
import closeIcon from "../../../common/assets/images/modal-close-icon.png";
import search_icon from "../../../common/assets/images/search-icon-new.png";
import urgentIcon from "../../../common/assets/images/Variation 2.png";
import {
  Table,
  Badge,
  Form,
  Pagination,
  Dropdown,
  Button,
  Card,
  Placeholder,
  Spinner,
} from "react-bootstrap";
import "../CoderView/CoderView.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatCalenderDate } from "../../CodingScreen/utils";
import { useDispatch, useSelector } from "react-redux";
import HealthInformationManagerAssignModal from "../HealthInsuranceManager/HealthInformationManagerAssignModal";
import {
  resetSearchedCodersData,
  updateSpecialityPageNumber,
  updateUserAssginedFilters,
} from "./redux/CoderScreenSlice";
import {
  fetchCodersData,
  fetchCoderQueueFilters,
  fetchStatsData,
  fetchCoderSpecialityData,
  fetchCoderStatusPriority,
  fetchCoderURNumber,
  fetchSearchedCoderDetails,
  fetchUserPreferences,
  fetchCodersQueueData,
} from "./redux/CoderScreenSlice";
import { debounce, filter } from "lodash";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { updateAuditorPage } from "../AuditorView/redux/AuditorViewSlicer";
import {
  resetDocumentViewerError,
  resetDocumentViewerLoadedData,
  resetEpisodeIdentifierTopassDocumentViewer,
} from "../../DocumentViewer/redux/DocumentViewerSlicer";
import { selectedEpisodeList } from "../../pages/EpisodeList/redux/EpisodeListSlicer";
// import { updateAuditorPage } from "../AuditorView/redux/AuditorViewSlicer";
import { useMediaQuery } from "@mui/material";
import CoderSideDrawer from "./mobile/CoderSideDrawer";
import InfiniteScroll from "../../../components/codercompanion/components/infinite-scroll";

const CoderView = () => {
  const isMobile = useMediaQuery("(max-width: 1024px)");
  // declaration
  const dispatch = useDispatch();
  const dateFormat = "dd-MM-yyyy";

  // selectors
  const {
    healthInsuranceManagerFiltersPriority,
    healthInsuranceManagerFiltersStatus,
  } = useSelector(
    (state) => state.healthInsuranceManager.healthInsuranceManagerFilters
  );
  const navigate = useNavigate();
  // const {
  //   specialityPageNumber,
  //   specialityData,
  //   specialityLoading,
  //   specialityError,
  //   isSpecialityPageTrue,
  // } = useSelector((state) => state.healthInsuranceManager.speciality);
  const {
    usersPageNumber,
    usersData,
    usersLoading,
    usersError,
    isUserPageTrue,
  } = useSelector((state) => state.healthInsuranceManager.users);
  const [showUserPreferenceModal, setShowUserPreferenceModal] = useState(false);
  const { queueData, queueLoading } = useSelector(
    (state) => state.healthInsuranceManager.queue
  );
  const filtersPayload = useSelector(
    (state) => state.coderscreenqueue.coderFilter
  );
  const { episodeAssignmentPayload } = useSelector(
    (state) => state.healthInsuranceManager
  );
  const [queues, setQueues] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [isQueueFetching, setIsQueueFetching] = useState(false);

  const containerRef = useRef(null);
  const pageRef = useRef(1);
  const queueLengthRef = useRef(0);
  // states
  const [episodesCurrentPage, setEpisodesCurrentPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);
  const codersData = useSelector((state) => state.coderscreenqueue.codersData);
  const codersQueueData = useSelector(
    (state) => state.coderscreenqueue.coderQueuesData
  );
  const queueFiltersData = useSelector(
    (state) => state.coderscreenqueue.queueFiltersData
  );
  const statsLoading = useSelector(
    (state) => state.coderscreenqueue.loadingStatsData
  );
  const coderStatsData = useSelector(
    (state) => state.coderscreenqueue.statsData
  );
  const {
    codersSpecialityData,
    isSpecialityPageTrue,
    loadingSpecialityData,
    specialityPageNumber,
  } = useSelector((state) => state.coderscreenqueue.codersSpeciality);
  const codersStatusPriorityData = useSelector(
    (state) => state.coderscreenqueue.codersStatusPriorityData
  );
  const codersURNumberData = useSelector(
    (state) => state.coderscreenqueue.coderURNumberData
  );
  const userPreferences = useSelector(
    (state) => state.coderscreenqueue.preferencesData
  );
  const searchedCodersData = useSelector(
    (state) => state.coderscreenqueue.codersSearchedData
  );
  const [URpageNumber, setURPageNumber] = useState(1);
  const fetchedPages = useRef(new Set()); // tracks fetched pages
  const isFetching = useRef(false);
  const codersDataLoading = useSelector(
    (state) => state.coderscreenqueue.loadingCodersData
  );
  const preferencesLoading = useSelector(
    (state) => state.coderscreenqueue.loadingPreferencesData
  );
  const codersDataErrors = useSelector(
    (state) => state.coderscreenqueue.errorCodersData
  );
  const debouncedCoderSearch = useRef();
  const [workflowHimsAssginModal, setWorkflowHimsAssginModal] = useState(false);
  const [episodesPerPage, setEpisodesPerPage] = useState(10);
  const [selectedHimEpisodes, setSelectedHimEpisodes] = useState([]);
  const [isAllEpisodesSelected, setIsAllEpisodesSelected] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [showFilterSection, setShowFilterSection] = useState(true);
  const [appliedFilterModal, setAppliedFilterModal] = useState(false);
  const [episodesData, setEpisodesData] = useState();
  const [specialitySearchValue, setSpecialitySearchValue] = useState("");
  const [currentQueueSearchValue, setCurrentQueueSearchValue] = useState("");
  const [codersSearchValue, setCodersSearchValue] = useState("");
  const [prioritySearchValue, setPrioritySearchValue] = useState("");
  const [statusSearchValue, setStatusSearchValue] = useState("");
  const [queuesFilters, setQueueFilters] = useState([]);
  const [specialityPageNumbers, setspecialityPageNumber] = useState(1);
  const [coderSearchTerm, setCoderSearchTerm] = useState("");
  const [episodesToDisplay, setEpisodesToDisplay] = useState([]);
  const [hasURNumMore, setHasURNUMMore] = useState(true);
  const totalPages =
    typeof codersData?.episode_meta_data?.meta?.total_count === "number" &&
      typeof 10 === "number" &&
      10 > 0
      ? Math.ceil(codersData?.episode_meta_data?.meta?.total_count / 10)
      : 0;
  // const indexOfLastEpisode = filtersPayload.page_number * episodesPerPage;
  // const indexOfFirstEpisode = indexOfLastEpisode - episodesPerPage;
  // const currentEpisodesList = episodesData?.slice(
  // indexOfFirstEpisode,
  // indexOfLastEpisode
  // );
  // const dataToDisplay = episodesData?.length > 0 && episodesData;
  const codingDashboardOptions =
    codersData?.cards?.[0] &&
    Object.keys(codersData.cards[0]).map((item) => {
      return {
        name:
          item === "urgent"
            ? "Urgent"
            : item === "overdue"
              ? "Overdue"
              : item === "episode_to_be_audited"
                ? "Episodes to Audit"
                : item === "cdq_for_review"
                  ? "CDQs for Review"
                  : "",
        count: codersData.cards[0][item],
        icon:
          item === "urgent"
            ? urgentIcon
            : item === "overdue"
              ? unassignedIcon
              : item === "episode_to_be_audited"
                ? uncodedIcon
                : item === "cdq_for_review"
                  ? inprogressIcon
                  : "",
        tooltipContent:
          item === "urgent"
            ? "You have 10 uncoded episodes awaiting coding"
            : item === "overdue"
              ? "You have 10 unassigned episodes pending allocation"
              : item === "episode_to_be_audited"
                ? "You have 10 episodes that are overdue for completion"
                : item === "cdq_for_review"
                  ? "You have 10 ongoing episodes in progress"
                  : "",
        backgroundColor:
          item === "urgent"
            ? "#FEF2F2"
            : item === "overdue"
              ? "#FEFCE8"
              : item === "episode_to_be_audited"
                ? "#EFF6FF"
                : item === "cdq_for_review"
                  ? "#ECFDF5"
                  : "",
      };
    });

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      const payload = {
        ...filtersPayload,
        page_number: pageNumber,
      };
      dispatch(fetchCodersData(payload));
      // .then((res) => {
      //   setEpisodesToDisplay(res.payload.episodes);
      // });
      dispatch(updateUserAssginedFilters(payload));
      // setEpisodesCurrentPage(pageNumber);
    }
  };
  const handleCoderSelectChange = (fieldName, value, id) => {
    const currentValues = filtersPayload[fieldName] || [];
    let updatedValues = [];

    if (Array.isArray(value)) {
      updatedValues = value;
    } else {
      updatedValues = currentValues.includes(value)
        ? currentValues.filter((item) => item !== value)
        : [...currentValues, value];
    }

    const updatedFilters = {
      ...filtersPayload,
      [fieldName]: updatedValues,
    };

    dispatch(updateUserAssginedFilters(updatedFilters));
    // console.log(updatedFilters, "updatedFilters");
    dispatch(fetchCodersData({ ...updatedFilters }));
    // .then((res) => {
    //   setEpisodesToDisplay(res.payload.episodes);
    // });
    dispatch(fetchStatsData({ ...updatedFilters }));
    const { page_number, ...rest } = updatedFilters;
    const updatedFiltersWithQueuePage = {
      ...rest,
      queue_page_number: page_number,
    };

    dispatch(fetchCodersQueueData({ ...updatedFiltersWithQueuePage }));
  };

  const handleHimDatePickerChange = (fieldName, date) => {
    let filteredData = episodesData;

    const updatedFilters = {
      ...filtersPayload,
      [fieldName === fieldName ? fieldName : fieldName]:
        formatCalenderDate(date),
    };

    if (updatedFilters.separation_date_from) {
      filteredData = filteredData?.filter(
        (item) =>
          item.separation_date_from === updatedFilters.separation_date_from
      );
    }

    if (updatedFilters.separation_date_to) {
      filteredData = filteredData?.filter(
        (item) => item.separation_date_to === updatedFilters.separation_date_to
      );
    }
    dispatch(updateUserAssginedFilters(updatedFilters));
    dispatch(fetchCodersData(updatedFilters));
    // .then((res) => {
    //   setEpisodesToDisplay(res.payload.episodes);
    // });
    dispatch(fetchStatsData(updatedFilters));
    const { page_number, ...rest } = updatedFilters;
    const updatedFiltersWithQueuePage = {
      ...rest,
      queue_page_number: page_number,
    };

    dispatch(fetchCodersQueueData({ ...updatedFiltersWithQueuePage }));
  };

  const hanldeSelectQueueEpisodes = (type, data) => {
    if (type === "queue") {
      const payload = {
        ...filtersPayload,
        // ur_number: [],
        queue: [data?.queue_id],
      };
      dispatch(updateUserAssginedFilters(payload));
      dispatch(fetchCodersData(payload));
      // .then((res) => {
      //   setEpisodesToDisplay(res.payload.episodes);
      // });
      dispatch(fetchStatsData(payload));
    }
  };

  const renderDropdownOptions = (type, options, selected, searchValue) => {
    return options
      ?.filter((item) => item.toLowerCase().includes(searchValue.toLowerCase()))
      .map((item) => (
        <Form.Check
          key={item}
          type="checkbox"
          className="workflow-coder-dropdown-menu-options"
          label={item}
          value={item}
          checked={selected?.includes(item)}
          onChange={() => handleCoderSelectChange(type, item)}
        />
      ));
  };

  const handleDragStart = (e, item) => {
    e.dataTransfer.setData("application/json", JSON.stringify(item));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, queriesItem) => {
    e.preventDefault();
    const item = JSON.parse(e.dataTransfer.getData("application/json"));
    setWorkflowHimsAssginModal(true);
    const selectedEpisodeToTransfer = {
      ...item,
      speciality: queriesItem.queue_name,
    };
    setSelectedRecord(selectedEpisodeToTransfer);
  };

  const handleFilterRemove = (filterName, item) => {
    const updatedFilterObj = { ...filtersPayload };
    if (Array.isArray(updatedFilterObj[filterName])) {
      updatedFilterObj[filterName] = updatedFilterObj[filterName].filter(
        (value) => value !== item
      );
    } else {
      updatedFilterObj[filterName] = filterName === "date" ? null : "";
    }
    dispatch(updateUserAssginedFilters(updatedFilterObj));
    dispatch(fetchCodersData(updatedFilterObj));
    // .then((res) => {
    //   setEpisodesToDisplay(res.payload.episodes);
    // });
    dispatch(fetchStatsData(updatedFilterObj));
    const { page_number, ...rest } = updatedFilterObj;
    const updatedFiltersWithQueuePage = {
      ...rest,
      queue_page_number: page_number,
    };

    dispatch(fetchCodersQueueData({ ...updatedFiltersWithQueuePage }));
    // setFilterEpisodes(updatedFilterObj);
  };
  // console.log(filtersPayload, "filtersPayload");
  const keysToRemove = ["page_number"];
  const newObj = { ...filtersPayload };
  keysToRemove.forEach((key) => {
    delete newObj[key];
  });

  const hasValue = Object.values(newObj).some(
    (item) =>
      item !== "" &&
      item !== null &&
      (Array.isArray(item) ? item.length > 0 : true)
  );

  const handleReset = () => {
    const resetState = {
      separation_date_from: null,
      separation_date_to: null,
      speciality: [],
      queue: [],
      queue_priority: [],
      status: [],
      queue_page_number: 1,
      page_number: 1,
      ur_number: [],
    };
    dispatch(updateUserAssginedFilters(resetState));
    dispatch(fetchCodersData(resetState));
    // .then((res) => {
    //   setEpisodesToDisplay(res.payload.episodes);
    // });
    dispatch(fetchStatsData(resetState));
    dispatch(fetchCodersQueueData(resetState));
    // setFilterEpisodes(resetState);
  };

  // useEffect(() => {
  //   dispatch(getHealthInsuranceManagerFilterOptions());
  //   // dispatch(fetchCodersData(filtersPayload)).then((res) => {
  //   //   setEpisodesToDisplay(res.payload.episodes);
  //   // });
  // }, []);

  // useEffect(() => {
  //   if (isQueuePageTrue && !queueLoading) {
  //     dispatch(updateQueuePageNumber(queuePageNumber + 1));
  //     dispatch(queueOptions(queuePageNumber + 1));
  //   }
  // }, [isQueuePageTrue, queueLoading]);

  useEffect(() => {
    if (isSpecialityPageTrue && !loadingSpecialityData) {
      dispatch(updateSpecialityPageNumber(specialityPageNumber + 1));
      dispatch(fetchCoderSpecialityData(specialityPageNumber + 1));
    }
  }, [isSpecialityPageTrue, loadingSpecialityData]);

  // useEffect(() => {
  //   if (isUserPageTrue && !usersLoading) {
  //     dispatch(updateUserPageNumber(usersPageNumber + 1));
  //     dispatch(usersOptions(usersPageNumber + 1));
  //   }
  // }, [isUserPageTrue, usersLoading]);

  // useEffect(() => {
  //   setEpisodesData(healthInsuranceManagerData.episodes);
  // }, [healthInsuranceManagerData]);

  const getValueFromApi = (key, itemId) => {
    if (key === "queue") {
      const queues = queuesFilters;
      const matchedQueue = queues.find((q) => q?.queue_id === itemId);
      return matchedQueue?.queue_name || itemId;
    }
    return itemId;
  };
  useEffect(() => {
    // const fetchData = async () => {
    //   try {
    //     const resultAction = await dispatch(getAuditorViewData(filtersPayload));
    //     const responseData = resultAction.payload;
    //     setEpisodesToDisplay(responseData?.episodes);
    //     console.log(responseData, "checkresdata");

    //     if (!responseData || responseData.episodes.length === 0) {
    //       setHasMoreData(false);
    //     } else {
    //       setHasMoreData(true);
    //     }
    //   } catch (error) {
    //     console.error("Failed to fetch data:", error);
    //     setHasMoreData(false);
    //   }
    // };

    // fetchData();
    dispatch(fetchCodersData(filtersPayload));
    // .then((res) => {
    //   setEpisodesToDisplay(res.payload.episodes);
    // });
    // dispatch(fetchCodersQueueData(filtersPayload))
  }, []);
  useEffect(() => {
    const { page_number, ...rest } = filtersPayload;
    const initialPayload = {
      ...rest,
      queue_page_number: 1,
    };

    dispatch(fetchCodersQueueData(initialPayload)).then((res) => {
      const response = res.payload;
      setQueues(response.queues);
      setTotalCount(response.episode_queue_meta_data?.meta?.total_count || 0);
      setPage(1);
      queueLengthRef.current = response?.queues?.length;
      pageRef.current = 1;
    });
  }, [dispatch]);

  // Scroll handler with proper protection
  useEffect(() => {
    const container = containerRef?.current;
    if (!container) return;

    const handleScroll = () => {
      if (isQueueFetching) return;
      if (queueLengthRef.current >= totalCount) return;

      const reachedBottom =
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 5;

      if (reachedBottom) {
        const nextPage = pageRef.current + 1;

        const { page_number, ...rest } = filtersPayload;
        const payloadWithPage = {
          ...rest,
          queue_page_number: nextPage,
        };

        setIsQueueFetching(true);
        dispatch(fetchCodersQueueData(payloadWithPage))
          .then((res) => {
            const response = res.payload;

            if (!response.queues || response.queues.length === 0) {
              setIsQueueFetching(false);
              return;
            }

            setQueues((prev) => {
              const updated = [...prev, ...response.queues];
              queueLengthRef.current = updated.length;
              return updated;
            });

            setPage(nextPage);
            pageRef.current = nextPage;
            setIsQueueFetching(false);
          })
          .catch(() => setIsQueueFetching(false));
      }
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [filtersPayload, totalCount, isQueueFetching]);

  const fetchAllQueueFilters = async () => {
    let page = 1;
    let hasMore = true;

    while (hasMore) {
      try {
        const response = await dispatch(fetchCoderQueueFilters(page)).unwrap();

        // Append fetched queues to state
        setQueueFilters((prev) => [...prev, ...response.queues.queues_data]);

        hasMore = response.queues.queue_name_still_available;
        page += 1;
      } catch (error) {
        // console.error("Error fetching queues:", error);
        hasMore = false;
      }
    }
  };

  useEffect(() => {
    fetchAllQueueFilters();
  }, []);
  useEffect(() => {
    const payload = {
      separation_date_from: null,
      separation_date_to: null,
      speciality: [],
      queue: [],
      queue_priority: [],
      status: [],
      coders: [],
    };
    dispatch(fetchStatsData(payload));
  }, [dispatch]);
  const totalEpisodesObj = coderStatsData?.stats?.find(
    (item) => item.total_number_of_episodes !== undefined
  );
  const totalNumberOfEpisodes = totalEpisodesObj?.total_number_of_episodes;
  const weightObj = coderStatsData?.stats?.find(
    (item) => item?.total_weight  !== undefined
  );
  const totalEpisodesWeight = weightObj?.total_weight ?? 0;
  // console.log("fetchCoderQueueFilters", episodesToDisplay);
  // useEffect(() => {
  //   dispatch(fetchCoderSpecialityData(specialityPageNumbers));
  // }, [dispatch, specialityPageNumbers]);

  // Watch for `has_more` in the response
  useEffect(() => {
    if (codersSpecialityData?.has_more) {
      setspecialityPageNumber((prevPage) => prevPage + 1);
    }
  }, [codersSpecialityData?.has_more]);
  useEffect(() => {
    dispatch(fetchCoderStatusPriority());
    // dispatch(fetchCoderURNumber());
  }, [dispatch]);
  useEffect(() => {
    const alreadyFetched = fetchedPages.current.has(URpageNumber);
    if (!alreadyFetched && !isFetching.current) {
      isFetching.current = true;

      dispatch(fetchCoderURNumber(URpageNumber)).then((res) => {
        isFetching.current = false;

        const data = res.payload;
        if (!data) return;
    
        fetchedPages.current.add(URpageNumber);
       if (data.episodes_with_ur_number.length === 0 || !data.has_more) {
        setHasURNUMMore(false); // Stop future fetching
      }
   
      });
    }
  }, [URpageNumber, dispatch]);
const handleURScroll = (e) => {
  const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10 && hasURNumMore) {
    // console.log("Loading next page...");
    setURPageNumber((prev) => prev + 1);
  }
};
  // console.log(filtersPayload, "filt");


  // useEffect(() => {
  //   debouncedCoderSearch.current = debounce(async (value) => {
  //     if (value.trim()) {
  //       try {
  //         const updatedFiltersPayload = {
  //           ...filtersPayload,
  //           search_term: value,
  //         };
  //         const resultAction = await dispatch(
  //           fetchCodersData(updatedFiltersPayload)
  //         );
  //         console.log(resultAction,'resultAction');

  //         const response = resultAction.payload;
  //         setEpisodesToDisplay(response?.episodes || []);
  //       } catch (error) {
  //         console.error("Search failed:", error);
  //         setEpisodesToDisplay([]);
  //       }
  //     }
  //   }, 100);

  //   return () => {
  //     debouncedCoderSearch.current.cancel();
  //   };
  // }, [dispatch]);
  // const handleSearchEpisode = (e) => {
  //   const payload = {
  //     ...filtersPayload,
  //     episode_identifier_search:  e?.target?.value?.length > 0 ? e?.target?.value : ''  ,
  //   };
  //   dispatch(updateFilters(payload));
  //   dispatch(getHealthInformationQueueManagerData(payload))
  //   debounceSearchHandler(payload);
  //   // if (e?.target?.value?.trim() === "") {
  //   //   console.log(e?.target?.value, 'office')
  //   //   setEpisodeIdentifierSearchModal(false);
  //   // }
  // }

  const handleCoderEpisodesSearch = (e) => {
    const value = e.target.value;
    setCoderSearchTerm(value);
    const payload = {
      ...filtersPayload,
      search_term: value,
    };
    dispatch(updateUserAssginedFilters(payload));
    dispatch(fetchCodersData(payload)).then((res) => {
      // const responseData = resultAction.payload;
      // console.log(res,'codrviwh');

      setEpisodesToDisplay(res?.payload?.episodes || []);
    });
    dispatch(fetchStatsData(payload));
    dispatch(fetchCodersQueueData(payload));
    // if (value.trim() === "") {
    //   debouncedCoderSearch.current.cancel();

    //   // Refetch the original data for page 1
    //   const payload = {
    //     separation_date_from: null,
    //     separation_date_to: null,
    //     speciality: [],
    //     queue: [],
    //     queue_priority: [],
    //     status: [],
    //     queue_page_number: 1,
    //     page_number: 1,
    //   };
    //   dispatch(updateUserAssginedFilters(filtersPayload));
    //   dispatch(fetchCodersData(filtersPayload));
    //   // .then((resultAction) => {
    //   //   const responseData = resultAction.payload;
    //   //   setEpisodesToDisplay(responseData?.episodes || []);
    //   // });
    //   dispatch(fetchStatsData(filtersPayload));
    //   dispatch(fetchCodersQueueData(filtersPayload));
    // } else {
    //   debouncedCoderSearch.current(value);
    // }
  };
  const checkPermissionAndNavigate = (selectedRecord) => {
    const updatedRecord = {
      ...selectedRecord,
      episode_identifier: selectedRecord.medical_record_number,
    };
    localStorage.setItem("last_hcp_line_id", updatedRecord?.hcp_line_id);
    dispatch(resetEpisodeIdentifierTopassDocumentViewer());
    // localStorage.setItem("filters", JSON.stringify(filtersPayload));
    localStorage.setItem("currentPage", "coderview");
    dispatch(resetDocumentViewerLoadedData());
    dispatch(selectedEpisodeList(updatedRecord));
    dispatch(resetDocumentViewerError());
    dispatch(fetchUserPreferences()).then((res) => {
      const preferences = res.payload; // get the latest preferences from thunk result

      if (preferences["Code Accelerate"] && preferences["Code Assist"]) {
        setShowUserPreferenceModal(true);
      } else if (preferences["Code Accelerate"]) {
        navigate("/coder", { state: { from: "coder" } });
      } else if (preferences["Code Assist"]) {
        navigate("/Code-Assist", { state: { from: "coder" } });
      } else {
        toast.error("You are not subscribed to any of the coding module");
      }
    });
  };
  // console.log(codersData);

  const navigateToDesiredPage = (type) => {
    if (type === "accelerate") {
      navigate("/coder", { state: { from: "coder" } });
    } else if (type === "assist") {
      navigate("/Code-Assist", { state: { from: "coder" } });
    }
    localStorage.setItem('filters', JSON.stringify(filtersPayload));
    dispatch(updateAuditorPage(false));

    setShowUserPreferenceModal(false);
  };
  // console.log(episodesToDisplay, "userPreferences");
  return (
    <div className="workflow-coder-container coder-screen">
      {!isMobile && (
        <div lg="3" sm="12" xs="12" md="12" className="left-coder-workflow-card">
          <div className="left-coder-workflow-card-header">
            <img
              src={backIcon}
              className="left-coder-workflow-card-icon"
              onClick={() => navigate('/Code-Workflow')}
            />
            <p className="left-coder-workflow-card-text">Back to Workflow</p>
          </div>
          <div className="left-coder-workflow-queues-card">
            <p className="left-coder-workflow-queues-card-header">Queues</p>
            <div className="coder-workflow-queues-container" ref={containerRef}>
              {isQueueFetching ? (
                <div className="left-coder-workflow-queues-card-top">
                  {/* <LdsRoller/>  */}
                  <div style={{ width: "100%", minHeight: "300px" }}>
                    <Placeholder animation="glow">
                      <Placeholder xs={12} className="queuePlaceholder" />
                    </Placeholder>
                  </div>
                </div>
              ) : codersDataErrors ? (
                <div className="left-coder-workflow-queues-error">
                  {" "}
                  No queues found{" "}
                </div>
              ) : (
                queues?.map((queriesItem) => (
                  <div
                    className="left-coder-workflow-queues-card-top"
                    key={queriesItem.queue_id}
                    onDragOver={handleDragOver}
                    onDrop={(e) => handleDrop(e, queriesItem)}
                    onClick={() =>
                      hanldeSelectQueueEpisodes("queue", queriesItem)
                    }
                  >
                    <p className="left-coder-workflow-queues-card-icon">
                      <img src={generalsurgeryIcon} alt={queriesItem.queue_id} />
                    </p>
                    <p
                      className="left-coder-workflow-queues-card-name"
                    // title={queriesItem.queue_name}
                    >
                      {/* {queriesItem.queue_name.length > 20
                      ? `${queriesItem.queue_name[0].toUpperCase()}${queriesItem.queue_name.slice(
                          1,
                          10
                        )}...`
                      : `${queriesItem.queue_name[0].toUpperCase()}${queriesItem.queue_name.slice(
                          1
                        )}`} */}
                      {queriesItem?.queue_name?.length > 15 ? (
                        <Tooltip title={queriesItem.queue_name}>
                          {`${queriesItem.queue_name[0].toUpperCase()}${queriesItem.queue_name.slice(1, 15)}...`}
                        </Tooltip>
                      ) : (
                        `${queriesItem.queue_name[0].toUpperCase()}${queriesItem.queue_name.slice(1)}`
                      )}
                    </p>
                    <p className="left-coder-workflow-queues-card-count">
                      {`( ${queriesItem.number_of_episodes} )`}
                      {/* <Tooltip title={`This queue contains ${queriesItem.number_of_episodes} episode assigned for processing`}>
                      <FontAwesomeIcon icon={faCircleInfo}  className="coder-dashboard-tooltip"/>
                    </Tooltip> */}
                    </p>
                  </div>
                ))
              )}
            </div>
            <p className="left-coder-workflow-coders-card-header"> Coders </p>
            <div className="coder-workflow-queues-container">
              {codersDataLoading ? (
                <div className="left-coder-workflow-coders-card-top">
                  {/* <LdsRoller/>  */}
                  <div className="" style={{ width: "100%", minHeight: "300px" }}>
                    <Placeholder animation="glow">
                      <Placeholder xs={12} className="queuePlaceholder" />
                    </Placeholder>
                  </div>
                </div>
              ) : codersDataErrors ? (
                <div className="left-coder-workflow-coders-error">
                  {" "}
                  No coders found{" "}
                </div>
              ) : (
                codersData?.coders?.map((codersItem) => (
                  <div
                    className="left-coder-workflow-coders-card-top"
                    key={codersItem.coder_id}
                    onDragOver={handleDragOver}
                    onDrop={(e) => handleDrop(e, codersItem)}
                  // onClick={() => hanldeSelectQueueEpisodes("coder", codersItem)}
                  >
                    <p className="left-coder-workflow-coders-card-icon">
                      <img src={userIcon} alt={codersItem.coder_name} />
                    </p>
                    <p className="left-coder-workflow-coders-card-name">
                      {`${codersItem.coder_name
                        .slice(0, 1)
                        .toUpperCase()}${codersItem.coder_name.slice(1)}`}
                    </p>
                    <p className="left-coder-workflow-coders-card-count">
                      {`( ${codersItem.number_of_episodes} )`}
                      {/* <Tooltip className="coder-dashboard-tooltip"  title={`This coder contains ${codersItem.number_of_episodes} episode assigned for processing`}>
                      <FontAwesomeIcon icon={faCircleInfo}  />
                    </Tooltip> */}
                    </p>
                  </div>
                ))
              )}
            </div>
            <p className="left-coder-workflow-coders-card-header"> My Stats </p>
            {statsLoading ? (
              <Placeholder
                as={Card.Text}
                animation="glow"
                style={{ width: "100%" }}
              >
                <Placeholder xs={3} className="PlaceholderItem" />{" "}
                <Placeholder xs={3} className="PlaceholderItem" />{" "}
                <Placeholder xs={3} className="PlaceholderItem" />{" "}
                <Placeholder xs={2} className="PlaceholderItem" />
              </Placeholder>
            ) : (
              <div className="stats-top-wrapper">
                <div className="stats-value-wrapper">
                  <label>Coded</label>
                  <span>{totalNumberOfEpisodes}</span>
                </div>
                <div className="stats-value-wrapper">
                  <label>NWAU</label>
                  <span>
                    {totalEpisodesWeight === "null"
                      ? 0
                      : totalEpisodesWeight.toFixed(4)}
                  </span>
                </div>
                <div className="stats-value-wrapper">
                  <label>$</label>
                  <span>
                    {Math.round(totalEpisodesWeight * 6465).toLocaleString()}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="right-coder-workflow-card">
        {isMobile && (
          <div className="mobile-qc-header">
            <img
              src={backIcon}
              alt="back"
              className="mobile-qc-back-icon"
              onClick={() => navigate("/Code-Workflow")}
            />
            <span className="mobile-qc-back-text">Back to Workflow</span>
          </div>
        )}
        <div className="coder-dashboard">
          {codersDataLoading ? (
            <Placeholder
              as={Card.Text}
              animation="glow"
              style={{ width: "100%" }}
            >
              <Placeholder xs={3} className="PlaceholderItem" style={{ height: "85px" }} />{" "}
              <Placeholder xs={3} className="PlaceholderItem" style={{ height: "85px" }} />{" "}
              <Placeholder xs={3} className="PlaceholderItem" style={{ height: "85px" }} />{" "}
              <Placeholder xs={2} className="PlaceholderItem" style={{ height: "85px" }} />
            </Placeholder>
          ) : (
            // <LdsRoller/>
            codingDashboardOptions?.length > 0 &&
            codingDashboardOptions?.map((dashboardItem) => (
              <div
                key={dashboardItem.name}
                className="coder-dashboard-cards"
                style={{ backgroundColor: dashboardItem.backgroundColor }}
              >
                <div className="coder-dashboard-cards-top">
                  <p className="coder-dashboard-name">
                    {dashboardItem.name}
                    {/* <Tooltip title={dashboardItem.tooltipContent}>
                      <FontAwesomeIcon icon={faCircleInfo}  className="coder-dashboard-tooltip"/>
                    </Tooltip> */}
                  </p>
                  <p className="coder-dashboard-icon">
                    <img src={dashboardItem.icon} alt={dashboardItem.name} />
                  </p>
                </div>
                <p className="coder-dashboard-count">{dashboardItem.count}</p>
              </div>
            ))
          )}
        </div>
        {isMobile && (
          <div className="mobile-view-filter">
            <CoderSideDrawer
              handleDragOver={handleDragOver}
              handleDrop={handleDrop}
              hanldeSelectQueueEpisodes={hanldeSelectQueueEpisodes}
              healthInsuranceManagerData={{
                queues: queues || [],
                coders: codersData?.coders || [],
                stats: {
                  totalNumberOfEpisodes: totalNumberOfEpisodes || 0,
                  totalEpisodesWeight: totalEpisodesWeight || 0,
                },
              }}
            />
          </div>
        )}
        <div className={showFilterSection ? "workflow-coder-main-container-open" : "workflow-coder-main-container-close"}>
          <div className="workflow-coder-main-container-top">
            <p className="workflow-coder-main-container-name">Filters</p>
            <div>
              {hasValue && (
                <Button
                  className="workflow-coder-applied-filter-btn"
                  onClick={() => setAppliedFilterModal(!appliedFilterModal)}
                >
                  Applied Filter
                </Button>
              )}
              <span
                className="workflow-coder-main-container-icon"
                onClick={() => setShowFilterSection(!showFilterSection)}
              >
                <img src={workflowFilterIcon} alt="" />
              </span>
            </div>
          </div>
          {showFilterSection && (
            <>
              {/* <div className="workflow-coder-filter-section"> */}
              {appliedFilterModal && hasValue && (
                <div className="workflow-coder-filter-breadcrumb-section">
                  <div className="workflow-coder-filter-breadcrumb-list">
                    {Object.keys(filtersPayload).map((key) => {
                      const value = filtersPayload[key];
                      if (
                        key === "separation_date_from" ||
                        key === "separation_date_to"
                      ) {
                        return (
                          value && (
                            <Badge
                              key={key}
                              bg="light"
                              text="dark"
                              className="workflow-coder-filter-breadcrumbItem"
                            >
                              <span>
                                {key === "separation_date_from"
                                  ? "Separation Date From"
                                  : "Separation Date To"}{" "}
                                : {new Date(value).toLocaleDateString()}
                              </span>
                              <img
                                src={closeIcon}
                                height="15px"
                                width="15px"
                                onClick={() => handleFilterRemove(key)}
                                className="workflow-coder-filter-close-icon"
                                alt={`Remove filter: ${key}`}
                              />
                            </Badge>
                          )
                        );
                      }
                      if (
                        key === "speciality" ||
                        key === "status" ||
                        key === "queue_priority" ||
                        key === "ur_number" ||
                        key === "queue"
                      ) {
                        return (
                          <div className="workflow-coder-filter-breadcrumb-list">
                            {Array.isArray(value) ? (
                              value.map((item, index) => (
                                <Badge
                                  key={`${key}-${index}`}
                                  bg="light"
                                  text="dark"
                                  className="workflow-coder-filter-breadcrumbItem"
                                >
                                  <span>
                                    {/* {console.log(item, "item")} */}
                                    {key.length > 0 &&
                                      key.charAt(0).toUpperCase() +
                                      key.slice(1).replace("_", " ")}
                                    {/* {key} */}:
                                    {/* {item.length > 0 &&
                                        item.replace(".txt", "")} */}{" "}
                                    {getValueFromApi(key, item)}
                                  </span>
                                  <span>
                                    <img
                                      src={closeIcon}
                                      height="15px"
                                      width="15px"
                                      onClick={() =>
                                        handleFilterRemove(key, item)
                                      }
                                      className="workflow-coder-filter-close-icon"
                                      alt={`Remove filter: ${key}`}
                                    />
                                  </span>
                                </Badge>
                              ))
                            ) : (
                              <Badge
                                key={key}
                                bg="light"
                                text="dark"
                                className="workflow-coder-filter-breadcrumbItem"
                              >
                                <span>
                                  {key.charAt(0).toUpperCase() + key.slice(1)}:
                                  {value.includes("-")
                                    ? value.slice(0, value.indexOf("-"))
                                    : value}
                                </span>
                                <span>
                                  <img
                                    src={closeIcon}
                                    height="15px"
                                    width="15px"
                                    onClick={() =>
                                      handleFilterRemove(key, value)
                                    }
                                    className="workflow-coder-filter-close-icon"
                                    alt={`Remove filter: ${key}`}
                                  />
                                </span>
                              </Badge>
                            )}
                          </div>
                        );
                      }
                    })}
                  </div>
                  {hasValue && (
                    <div className="workflow-filters-reset-container">
                      {" "}
                      <Button
                        onClick={handleReset}
                        className="workflow-filters-reset-btn"
                      >
                        Clear All
                      </Button>
                    </div>
                  )}
                </div>
              )}
              {/* </div> */}

              <div className="workflow-coder-filter-container">
                <div className="workflow-coder-filter-card">
                  <label className="workflow-coder-filter-label">
                    Separation Date From
                  </label>
                  <DatePicker
                    selected={filtersPayload.separation_date_from || ""}
                    onChange={(date) => {
                      handleHimDatePickerChange("separation_date_from", date);
                    }}
                    dateFormat={dateFormat}
                    showYearDropdown
                    yearDropdownItemNumber={150}
                    scrollableYearDropdown
                    placeholderText="From"
                    className="workflow-coder-filter-date-picker"
                  />
                </div>
                <div className="workflow-coder-filter-card">
                  <label className="workflow-coder-filter-label">
                    Separation Date To
                  </label>
                  <DatePicker
                    selected={filtersPayload.separation_date_to || ""}
                    onChange={(date) => {
                      handleHimDatePickerChange("separation_date_to", date);
                    }}
                    dateFormat={dateFormat}
                    showYearDropdown
                    yearDropdownItemNumber={150}
                    scrollableYearDropdown
                    placeholderText="To"
                    className="workflow-coder-filter-date-picker"
                  />
                </div>
                <div className="workflow-coder-filter-card">
                  <label
                    className="workflow-coder-filter-label"
                    htmlFor="speciality"
                  >
                    Speciality/Unit
                  </label>
                  {/* <Select
                  isMulti
                  name="speciality"
                  options={HimTablefilterFieldsOptions?.speciality?.map(
                    (item) => ({
                      value: item,
                      label: item,
                    })
                  )}
                  value={getSelectedOptions("speciality")}
                  styles={customStyles}
                  className="workflow-coder-filter-select"
                  placeholder="All Specialty/Unit"
                  onChange={(selectedOption) => {
                    const selectedValues = selectedOption.map(
                      (option) => option.value
                    );
                    handleCoderSelectChange("speciality", selectedValues || []);
                  }}
                /> */}
                  <Dropdown className="workflow-coder-filter-card-dropdown">
                    <Dropdown.Toggle
                      id="speciality"
                      className="workflow-coder-filter-card-label"
                    >
                      Speciality
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="workflow-coder-filter-select">
                      <div>
                        <div>
                          {/* {!specialityLoading && specialityData?.length > 0 && ( */}
                          <input
                            className="workflow-coder-filter-dropdown-search-input"
                            type="text"
                            value={specialitySearchValue}
                            onChange={(e) =>
                              setSpecialitySearchValue(e.target.value)
                            }
                            placeholder="Search"
                          />
                          {/* )} */}
                        </div>
                        <div className="workflow-coder-filter-dropdown-options-container">
                          {/* {renderDropdownOptions(
                            "speciality",
                            // HimTablefilterFieldsOptions?.speciality,
                            specialityData.length > 0 ? specialityData : [],
                            filterEpisodes.speciality,
                            specialitySearchValue
                          )} */}
                          {loadingSpecialityData ? (
                            <div className="filter-loader">
                              <Spinner />
                            </div>
                          ) : codersSpecialityData?.length > 0 ? (
                            codersSpecialityData
                              .filter((item) =>
                                item
                                  ?.toLowerCase()
                                  ?.includes(
                                    specialitySearchValue?.toLowerCase()
                                  )
                              )
                              .map((item) => (
                                <Form.Check
                                  key={item}
                                  type="checkbox"
                                  className="workflow-coder-dropdown-menu-options"
                                  label={item}
                                  value={item}
                                  checked={
                                    filtersPayload.speciality?.includes(item) ||
                                    false
                                  }
                                  onChange={() =>
                                    handleCoderSelectChange("speciality", item)
                                  }
                                />
                              ))
                          ) : (
                            <div>No Data</div>
                          )}
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="workflow-coder-filter-card">
                  <label
                    className="workflow-coder-filter-label"
                    htmlFor="queue"
                  >
                    Current Queue
                  </label>
                  {/* <Select
                  isMulti
                  name="queue"
                  options={HimTablefilterFieldsOptions?.current_queue?.map(
                    (item) => ({
                      value: item,
                      label: item,
                    })
                  )}
                  value={getSelectedOptions("queue")}
                  styles={customStyles}
                  className="workflow-coder-filter-select"
                  placeholder="All Current Queue"
                  onChange={(selectedOption) => {
                    const selectedValues = selectedOption.map(
                      (option) => option.value
                    );
                    handleCoderSelectChange(
                      "queue",
                      selectedValues || []
                    );
                  }}
                /> */}
                  <Dropdown className="workflow-coder-filter-card-dropdown">
                    <Dropdown.Toggle
                      id="queue"
                      className="workflow-coder-filter-card-label"
                    >
                      Current Queue
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="workflow-coder-filter-select">
                      <div>
                        {/* {!queueLoading && queueData?.length > 0 && ( */}
                        <div>
                          <input
                            className="workflow-coder-filter-dropdown-search-input"
                            type="text"
                            value={currentQueueSearchValue}
                            onChange={(e) =>
                              setCurrentQueueSearchValue(e.target.value)
                            }
                            placeholder="Search"
                          />
                        </div>
                        {/* )} */}
                        {/* {filteredQueues?.map((item) => (
                        <Form.Check
                          key={item}
                          type="checkbox"
                          className="workflow-coder-dropdown-menu-options"
                          label={item}
                          value={item}
                          checked={filterEpisodes.queue?.includes(item)}
                          onChange={(e) =>
                            handleCoderSelectChange("queue", item || [])
                          }
                        />
                      ))} */}
                        <div className="workflow-coder-filter-dropdown-options-container">
                          {queueLoading ? (
                            <div className="filter-loader">
                              <Spinner />
                            </div>
                          ) : (
                            queuesFilters.length > 0 &&
                            queuesFilters
                              ?.filter((item) =>
                                item?.queue_name
                                  ?.toLowerCase()
                                  ?.includes(
                                    currentQueueSearchValue?.toLowerCase()
                                  )
                              )
                              .map((item) => (
                                <Form.Check
                                  key={item}
                                  type="checkbox"
                                  className="workflow-coder-dropdown-menu-options"
                                  label={item.queue_name}
                                  value={item.queue_id}
                                  checked={
                                    filtersPayload.queue?.includes(
                                      item.queue_id
                                    ) || false
                                  }
                                  onChange={() =>
                                    handleCoderSelectChange(
                                      "queue",
                                      item.queue_id
                                    )
                                  }
                                />
                              ))
                          )}
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="workflow-coder-filter-card">
                  <label
                    className="workflow-coder-filter-label"
                    htmlFor="coders"
                  >
                    UR Number
                  </label>
                  {/* <Select
                  isMulti
                  name="coders"
                  options={HimTablefilterFieldsOptions?.coders?.map(
                    (item) => ({
                      value: item,
                      label: item,
                    })
                  )}
                  value={getSelectedOptions("coders")}
                  styles={customStyles}
                  className="workflow-coder-filter-select"
                  placeholder="All Assigned Coder"
                  onChange={(selectedOption) => {
                    const selectedValues = selectedOption.map(
                      (option) => option.value
                    );
                    handleCoderSelectChange("coders", selectedValues || []);
                  }}
                /> */}
                  <Dropdown className="workflow-coder-filter-card-dropdown">
                    <Dropdown.Toggle
                      id="coders"
                      className="workflow-coder-filter-card-label"
                    >
                      All UR Number
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="workflow-coder-filter-select">
                          
                      <div>
                        {codersURNumberData &&
                          codersURNumberData?.episodes_with_ur_number?.length >
                          0 && (
                            <div>
                              <input
                                className="workflow-coder-filter-dropdown-search-input"
                                type="text"
                                value={codersSearchValue}
                                onChange={(e) =>
                                  setCodersSearchValue(e.target.value)
                                }
                                placeholder="Search"
                              />
                            </div>
                          )}
                        {/* {filteredCoders?.map((item) => (
                        <Form.Check
                          key={item}
                          type="checkbox"
                          className="workflow-coder-dropdown-menu-options"
                          label={item}
                          value={item}
                          checked={filterEpisodes.coders?.includes(item)}
                          onChange={(e) =>
                            handleCoderSelectChange("coders", item || [])
                          }
                        />
                      ))} */}
                        <div className="workflow-coder-filter-dropdown-options-container">
                          {/* {renderDropdownOptions(
                            "coders",
                            // HimTablefilterFieldsOptions?.assigned_coder,
                            usersData?.length > 0 ? usersData : [],
                            filterEpisodes.coders,
                            codersSearchValue
                          )} */}

                          <div className="workflow-coder-filter-dropdown-options-container" onScroll={handleURScroll}>
                            {codersURNumberData?.episodes_with_ur_number
                              ?.length > 0 ? (
                              codersURNumberData?.episodes_with_ur_number
                                ?.filter((item) =>
                                  item.ur_number
                                    ?.toLowerCase()
                                    .includes(codersSearchValue?.toLowerCase())
                                )
                                .map((item) => (
                                  <Form.Check
                                    key={item.ur_number}
                                    type="checkbox"
                                    className="workflow-coder-dropdown-menu-options"
                                    label={item.ur_number}
                                    value={item.ur_number}
                                    checked={
                                      filtersPayload.ur_number?.includes(
                                        item.ur_number
                                      ) || false
                                    }
                                    onChange={() =>
                                      handleCoderSelectChange(
                                        "ur_number",
                                        item.ur_number
                                      )
                                    }
                                  />
                                ))
                            ) : (
                              <div>No Data</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="workflow-coder-filter-card">
                  <label
                    className="workflow-coder-filter-label"
                    htmlFor="queue_priority"
                  >
                    Priority
                  </label>
                  {/* <Select
                  isMulti
                  name="queue_priority"
                  options={HimTablefilterFieldsOptions?.priority?.map(
                    (item) => ({
                      value: item,
                      label: item,
                    })
                  )}
                  value={getSelectedOptions("queue_priority")}
                  // value={
                  //   filterEpisodes.priority
                  //     ? {
                  //         value: filterEpisodes.priority,
                  //         label: filterEpisodes.priority,
                  //       }
                  //     : null
                  // }
                  styles={customStyles}
                  className="workflow-coder-filter-select"
                  placeholder="All Priority"
                  onChange={(selectedOption) => {
                    const selectedValues = selectedOption.map(
                      (option) => option.value
                    );
                    handleCoderSelectChange(
                      "queue_priority",
                      selectedValues || []
                    );
                  }}
                /> */}
                  <Dropdown className="workflow-coder-filter-card-dropdown">
                    <Dropdown.Toggle
                      id="queue_priority"
                      className="workflow-coder-filter-card-label"
                    >
                      Priority
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="workflow-coder-filter-select">
                      <div>
                        <div>
                          <input
                            className="workflow-coder-filter-dropdown-search-input"
                            type="text"
                            value={prioritySearchValue}
                            onChange={(e) =>
                              setPrioritySearchValue(e.target.value)
                            }
                            placeholder="Search"
                          />
                        </div>
                        {/* {filteredPrioritys?.map((item) => (
                        <Form.Check
                          key={item}
                          type="checkbox"
                          className="workflow-coder-dropdown-menu-options"
                          label={item}
                          value={item}
                          checked={filterEpisodes.queue_priority?.includes(
                            item
                          )}
                          onChange={(e) =>
                            handleCoderSelectChange(
                              "queue_priority",
                              item || []
                            )
                          }
                        />
                      ))} */}
                        <div className="workflow-coder-filter-dropdown-options-container">
                          {renderDropdownOptions(
                            "queue_priority",
                            codersStatusPriorityData?.priority?.length > 0
                              ? codersStatusPriorityData?.priority
                              : [],
                            filtersPayload?.queue_priority,
                            prioritySearchValue
                          )}
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="workflow-coder-filter-card">
                  <label
                    className="workflow-coder-filter-label"
                    htmlFor="status"
                  >
                    Status
                  </label>
                  {/* <Select
                  isMulti
                  name="status"
                  options={HimTablefilterFieldsOptions?.status?.map(
                    (item) => ({
                      value: item,
                      label: item,
                    })
                  )}
                  value={getSelectedOptions("status")}
                  styles={customStyles}
                  className="workflow-coder-filter-select"
                  placeholder="All Specialty/Unit"
                  onChange={(selectedOption) => {
                    const selectedValues = selectedOption.map(
                      (item) => (option) => option.value
                    );
                    handleCoderSelectChange("status", selectedOption || []);
                  }}
                /> */}
                  <Dropdown className="workflow-coder-filter-card-dropdown">
                    <Dropdown.Toggle
                      id="status"
                      className="workflow-coder-filter-card-label"
                    >
                      Status
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="workflow-coder-filter-select">
                      <div>
                        <div>
                          <input
                            className="workflow-coder-filter-dropdown-search-input"
                            type="text"
                            value={statusSearchValue}
                            onChange={(e) =>
                              setStatusSearchValue(e.target.value)
                            }
                            placeholder="Search"
                          />
                        </div>
                        {/* {filteredStatus?.map((item) => (
                        <Form.Check
                          key={item}
                          type="checkbox"
                          className="workflow-coder-dropdown-menu-options"
                          label={item}
                          value={item}
                          checked={filterEpisodes.status?.includes(item)}
                          onChange={(e) =>
                            handleCoderSelectChange("status", item || [])
                          }
                        />
                      ))} */}
                        <div className="workflow-coder-filter-dropdown-options-container">
                          {/* {renderDropdownOptions(
                            "status",
                            healthInsuranceManagerFiltersStatus?.length > 0
                              ? healthInsuranceManagerFiltersStatus
                              : [],
                              filtersPayload.status,
                            statusSearchValue
                          )} */}
                          {/* {console.log(healthInsuranceManagerFiltersStatus, 'dsdsd')} */}

                          {[
                            ...new Set(
                              codersStatusPriorityData?.status?.filter((item) =>
                                item
                                  ?.toLowerCase()
                                  .includes(statusSearchValue?.toLowerCase())
                              )
                            ),
                          ].map((item) => (
                            <Form.Check
                              key={item}
                              type="checkbox"
                              className="workflow-coder-dropdown-menu-options"
                              label={item}
                              value={item}
                              checked={
                                filtersPayload.status?.includes(item) || false
                              }
                              onChange={() =>
                                handleCoderSelectChange("status", item)
                              }
                            />
                          ))}
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </>
          )}
        </div>
        <div
          className="workflow-coder-table-container"
          style={{ overflowX: "auto" }}
        >
          <div className="workflow-coder-table-header">
            {/* <div>
              {selectedHimEpisodes?.length > 0 && (
                <Badge
                  className="workflow-coder-table-td-assgine-btn"
                  onClick={() => {
                    setWorkflowHimsAssginModal(true);
                  }}
                >
                  Assign
                </Badge>
              )}
            </div> */}
            <div className="coder-screen-search">
              <img src={search_icon} alt="search" />
              <input
                type="text"
                placeholder="Search"
                onChange={(e) => handleCoderEpisodesSearch(e)}
                value={coderSearchTerm}
              />
            </div>
            {selectedHimEpisodes.length > 0 ? (
              <div className="workflow-coder-selected-rows-count">
                <Badge colorlassName="workflow-coder-selected-rows-count-badge">
                  Selected Rows:
                  {selectedHimEpisodes.length}
                </Badge>
              </div>
            ) : (
              <div className="workflow-coder-selected-rows-count">
                <Badge colorlassName="workflow-coder-selected-rows-count-badge">
                  Total Episodes:{" "}
                  {codersData?.episode_meta_data?.meta?.total_count
                    ? codersData?.episode_meta_data?.meta?.total_count
                    : 0}
                </Badge>
              </div>
            )}
          </div>
         <div className="workflow-coder-table-body">
          <Table
            // responsive="sm"
            className="workflow-table-Hims"
            // style={{ width: healthInsuranceManagerData ? "max-content" : "" }}
            style={{ width: "100%" }}
          >
            <thead className="workflow-coder-table-thead">
              <tr className="workflow-coder-table-tr">
                <th className="workflow-coder-table-th-select">
                  {/* <input
                    type="checkbox"
                    onChange={hanldeSelectAllHimEpisodes}
                    checked={isAllEpisodesSelected}
                    className="workflow-coder-table-input"
                  /> */}
                </th>
                <th className="workflow-coder-table-th">
                  <span>Episode Identifier</span>
                </th>
                <th className="workflow-coder-table-th">
                  <span>Admission Date</span>
                </th>
                <th className="workflow-coder-table-th">
                  <span>Discharge Date</span>
                </th>
                <th className="workflow-coder-table-th">
                  <span>LOS</span>
                </th>
                <th className="workflow-coder-table-th">
                  <span>Specialty/Unit</span>
                </th>
                <th className="workflow-coder-table-th">
                  <span>Provisional DRG</span>
                </th>
                <th className="workflow-coder-table-th">
                  <span>NWAU</span>
                </th>
                <th className="workflow-coder-table-th">
                  <span>$</span>
                </th>
                <th className="workflow-coder-table-th">
                  <span>Current Queue</span>
                </th>
                {/* <th className="workflow-coder-table-th">
                  <span>Assigned User</span>
                </th> */}
                <th className="workflow-coder-table-th">
                  <span>Priority</span>
                </th>
                <th className="workflow-coder-table-th">
                  <span>Status</span>
                </th>
              </tr>
            </thead>
            <tbody className="workflow-coder-table-body">
              {/* {HimFilterTableData ? (
                  <td colspan="10">
                    <div className="episodelist-table-loader">
                      <Spinner />{" "}
                    </div>
                  </td>
                ) : episodesFilterListError ? (
                  <td colspan="10">
                    <div className="episodelist-table-loader1">
                      {episodesFilterListError}
                    </div>
                  </td>
                ) : dataToDisplay?.length > 0 ? ( */}

              {codersDataLoading ? (
                <td colspan="10">
                  <div className="workflow-coder-table-loader">
                    <LdsRoller />
                  </div>
                </td>
              ) : codersDataErrors ? (
                <td colspan="10">
                  <div className="workflow-coder-table-error">
                    No data found
                  </div>
                </td>
              ) : coderSearchTerm?.length > 0 ? (
                episodesToDisplay?.map((HimTableItem, index) => (
                  <tr
                    key={HimTableItem.medical_record_number}
                    // style={{ borderBottom: "1px solid #E5E7EB" }}
                    // draggable
                    // onDragStart={(e) => handleDragStart(e, HimTableItem)}
                    className="workflow-coder-table-tr"
                    // onDoubleClick={() => {
                    //   navigate("/coder");
                    //   dispatch(
                    //     resetEpisodeIdentifierTopassDocumentViewer()
                    //   );
                    //   dispatch(resetDocumentViewerLoadedData());
                    //   dispatch(selectedEpisodeList(episode));
                    //   dispatch(resetDocumentViewerError());
                    // }}
                    onDoubleClick={() =>
                      checkPermissionAndNavigate(HimTableItem)
                    }
                  >
                    <td className="workflow-him-table-td">
                      {/* <input
                          type="checkbox"
                          className="workflow-him-table-input"
                          checked={selectedHimEpisodes?.some(
                            (episode) =>
                              episode === HimTableItem.medical_record_number
                          )}
                          onChange={(e) =>
                            handleHimRowSelection(e, HimTableItem)
                          }
                        /> */}
                    </td>
                    <td className="workflow-him-table-td">
                      {HimTableItem.medical_record_number}
                    </td>
                    <td className="workflow-him-table-td">
                      {HimTableItem.admission_date}
                    </td>
                    <td className="workflow-him-table-td">
                      {HimTableItem.separation_date}
                    </td>
                    <td className="workflow-him-table-td">
                      {HimTableItem.length_of_stay}
                    </td>
                    <td className="workflow-him-table-td">
                      {HimTableItem?.speciality
                        ? HimTableItem?.speciality
                        : "-"}
                    </td>
                    <td className="workflow-him-table-td">
                      {HimTableItem?.drg_code ? HimTableItem?.drg_code : "-"}
                    </td>
                    <td className="workflow-him-table-td">
                      {!isNaN(Number(HimTableItem?.weight))
                        ? Number(HimTableItem.weight).toFixed(4)
                        : "-"}
                    </td>
                    <td className="workflow-him-table-td">
                      {Number.isFinite(HimTableItem?.weight)
                        ? Math.round(HimTableItem.weight * 6465).toLocaleString(
                          "en-IN"
                        )
                        : "-"}
                    </td>
                    <td className="workflow-him-table-td">
                      <Badge className="workflow-him-current_queue">
                        <div>
                          <img
                            src={userIcon}
                            alt=""
                            height="15px"
                            width="15px"
                            className="me-2"
                          />
                        </div>
                        <div>{HimTableItem.queue}</div>
                        <div></div>
                      </Badge>
                    </td>
                    {/* <td className="workflow-him-table-td">
                        {HimTableItem?.assigned_user
                          ? HimTableItem?.assigned_user
                          : "-"}
                      </td> */}
                    <td className="workflow-him-table-td">
                      {/* {HimTableItem.Priority} */}
                      <Badge
                        className="workflow-him-priority"
                        ref={(el) => {
                          if (el) {
                            el.style.setProperty(
                              "background-color",
                              HimTableItem.priority === "URGENT"
                                ? "#FDF2FA"
                                : HimTableItem.priority === "HIGH"
                                  ? "#FEF6EE"
                                  : HimTableItem.priority === "LOW"
                                    ? "#F9FAFB"
                                    : HimTableItem.priority === "OVERDUE"
                                      ? "#FEFCE8"
                                      : "",
                              "important"
                            );
                            el.style.setProperty(
                              "border",
                              `1px solid ${HimTableItem.priority === "URGENT"
                                ? "#FCCEEE"
                                : HimTableItem.priority === "HIGH"
                                  ? "#F9DBAF"
                                  : HimTableItem.priority === "LOW"
                                    ? "#EAECF0"
                                    : HimTableItem.priority === "OVERDUE"
                                      ? "#F9DBAF"
                                      : ""
                              }`,
                              "important"
                            );
                            el.style.setProperty(
                              "color",
                              `${HimTableItem.priority === "URGENT"
                                ? "#C11574"
                                : HimTableItem.priority === "HIGH"
                                  ? "#D28800"
                                  : HimTableItem.priority === "LOW"
                                    ? "#344054"
                                    : HimTableItem.priority === "OVERDUE"
                                      ? "#344054"
                                      : ""
                              }`,
                              "important"
                            );
                          }
                        }}
                        style={{
                          border: "1px solid #FCCEEE",
                          backgroundColor: HimTableItem.PriorityColor,
                        }}
                      >
                        {HimTableItem.priority}
                        {/* Badge Content Here */}
                      </Badge>
                    </td>
                    <td className="workflow-him-table-td">
                      {/* <Badge
                        className="workflow-him-status"
                        ref={(el) => {
                          if (el) {
                            el.style.setProperty(
                              "background-color",
                              "#FFFF",
                              "important"
                            );
                            el.style.setProperty(
                              "border",
                              "1px solid #D0D5DD",
                              "important"
                            );
                            el.style.setProperty(
                              "color",
                              "#344054",
                              "important"
                            );
                          }
                        }}
                      >
                        <span
                          style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            backgroundColor:
                              HimTableItem.status === "in_progress"
                                ? "#316BFF"
                                : HimTableItem.status === "unassigned"
                                ? "#E5E7EB"
                                : HimTableItem.status === "overdue"
                                ? "#F26724"
                                : HimTableItem.status === "uncoded"
                                ? "#478754"
                                : "#4b5563",
                            marginRight: "5px",
                            // dis
                          }}
                        ></span>
                        <span>
                          {HimTableItem.status === "in_progress"
                            ? "In Progess"
                            : HimTableItem.status === "unassigned"
                            ? "Unassigned"
                            : HimTableItem.status === "overdue"
                            ? "Overdue"
                            : HimTableItem.status === "uncoded"
                            ? "Uncoded"
                            : HimTableItem.status}
                        </span>
                      </Badge> */}
                      <Badge
                        ref={(badge) => {
                          if (badge) {
                            // badge.style.setProperty(
                            //   "background-color",
                            //   episode?.status_color,
                            //   "important"
                            // );
                            badge.style.setProperty(
                              "background-color",
                              "#FFFF",
                              "important"
                            );
                            badge.style.setProperty(
                              "border",
                              "1px solid #D0D5DD",
                              "important"
                            );
                            badge.style.setProperty(
                              "color",
                              "#344054",
                              "important"
                            );
                            badge.style.setProperty("display", "flex");
                            // {episode.status === "AI processing complete - codes available for validation" ?  badge.style.setProperty("color", "white") : badge.style.setProperty("color", "#344054")}
                            badge.style.setProperty("align-items", "center");
                            badge.style.setProperty(
                              "justify-content",
                              "center"
                            );
                            badge.style.setProperty("height", "30px");
                            badge.style.setProperty("width", "100%");
                            // badge.style.setProperty("padding", "0px 20px");
                            badge.style.setProperty("font-size", "12px");
                            badge.style.setProperty("white-space", "normal"); // Allow text to wrap
                            badge.style.setProperty("overflow", "hidden"); // Hide overflowed text
                            badge.style.setProperty(
                              "text-overflow",
                              "ellipsis"
                            ); // Add ellipsis if text overflows
                          }
                        }}
                      >
                        {HimTableItem?.status || "-"}
                      </Badge>
                    </td>
                    {/* <td
                      className={`workflow-him-table-td ${
                        selectedHimEpisodes.includes(HimTableItem.medical_record_number)
                          ? "workflow-him-table-td-show"
                          : ""
                      }`}
                    >
                      {selectedHimEpisodes?.includes(
                        HimTableItem.medical_record_number
                      ) && (
                        <Badge
                          className="workflow-him-table-td-assgine-btn"
                          onClick={() => {
                            setWorkflowHimsAssginModal(true);
                            setSelectedRecord(HimTableItem);
                          }}
                        >
                          Assgin
                        </Badge>
                      )}
                    </td> */}
                  </tr>
                ))
              ) : codersData?.episodes?.length > 0 ? (
                codersData?.episodes?.map((HimTableItem, index) => (
                  <tr
                    key={HimTableItem?.medical_record_number}
                    // style={{ borderBottom: "1px solid #E5E7EB" }}
                    // draggable
                    // onDragStart={(e) => handleDragStart(e, HimTableItem)}
                    className="workflow-coder-table-tr"
                    // onDoubleClick={() => {
                    //   navigate("/coder");
                    //   dispatch(
                    //     resetEpisodeIdentifierTopassDocumentViewer()
                    //   );
                    //   dispatch(resetDocumentViewerLoadedData());
                    //   dispatch(selectedEpisodeList(episode));
                    //   dispatch(resetDocumentViewerError());
                    // }}
                    onDoubleClick={() =>
                      checkPermissionAndNavigate(HimTableItem)
                    }
                  >
                    <td className="workflow-him-table-td">
                      {/* <input
                          type="checkbox"
                          className="workflow-him-table-input"
                          checked={selectedHimEpisodes?.some(
                            (episode) =>
                              episode === HimTableItem.medical_record_number
                          )}
                          onChange={(e) =>
                            handleHimRowSelection(e, HimTableItem)
                          }
                        /> */}
                    </td>
                    <td className="workflow-him-table-td">
                      {HimTableItem?.medical_record_number}
                    </td>
                    <td className="workflow-him-table-td">
                      {HimTableItem?.admission_date}
                    </td>
                    <td className="workflow-him-table-td">
                      {HimTableItem?.separation_date!==null ? HimTableItem?.separation_date : "-"}
                    </td>
                    <td className="workflow-him-table-td">
                      {HimTableItem?.length_of_stay}
                    </td>
                    <td className="workflow-him-table-td">
                      {HimTableItem?.speciality
                        ? HimTableItem?.speciality
                        : "-"}
                    </td>
                    <td className="workflow-him-table-td">
                      {HimTableItem?.drg_code ? HimTableItem?.drg_code : "-"}
                    </td>
                    <td className="workflow-him-table-td">
                      {!isNaN(Number(HimTableItem?.weight))
                        ? Number(HimTableItem?.weight)?.toFixed(4)
                        : "-"}
                    </td>
                    <td className="workflow-him-table-td">
                      {Number.isFinite(HimTableItem?.weight)
                        ? Math.round(
                          HimTableItem?.weight * 6465
                        )?.toLocaleString("en-IN")
                        : "-"}
                    </td>
                    <td className="workflow-him-table-td">
                      <Badge className="workflow-him-current_queue">
                        <div>
                          <img
                            src={userIcon}
                            alt=""
                            height="15px"
                            width="15px"
                            className="me-2"
                          />
                        </div>
                        <div>{HimTableItem?.queue}</div>
                        <div></div>
                      </Badge>
                    </td>
                    {/* <td className="workflow-him-table-td">
                        {HimTableItem?.assigned_user
                          ? HimTableItem?.assigned_user
                          : "-"}
                      </td> */}
                    <td className="workflow-him-table-td">
                      {/* {HimTableItem.Priority} */}
                      <Badge
                        className="workflow-him-priority"
                        ref={(el) => {
                          if (el) {
                            el.style.setProperty(
                              "background-color",
                              HimTableItem?.priority === "URGENT"
                                ? "#FDF2FA"
                                : HimTableItem?.priority === "HIGH"
                                  ? "#FEF6EE"
                                  : HimTableItem?.priority === "LOW"
                                    ? "#F9FAFB"
                                    : HimTableItem?.priority === "OVERDUE"
                                      ? "#FEFCE8"
                                      : "",
                              "important"
                            );
                            el.style.setProperty(
                              "border",
                              `1px solid ${HimTableItem?.priority === "URGENT"
                                ? "#FCCEEE"
                                : HimTableItem?.priority === "HIGH"
                                  ? "#F9DBAF"
                                  : HimTableItem?.priority === "LOW"
                                    ? "#EAECF0"
                                    : HimTableItem?.priority === "OVERDUE"
                                      ? "#F9DBAF"
                                      : ""
                              }`,
                              "important"
                            );
                            el.style.setProperty(
                              "color",
                              `${HimTableItem?.priority === "URGENT"
                                ? "#C11574"
                                : HimTableItem?.priority === "HIGH"
                                  ? "#D28800"
                                  : HimTableItem?.priority === "LOW"
                                    ? "#344054"
                                    : HimTableItem?.priority === "OVERDUE"
                                      ? "#344054"
                                      : ""
                              }`,
                              "important"
                            );
                          }
                        }}
                        style={{
                          border: "1px solid #FCCEEE",
                          backgroundColor: HimTableItem?.PriorityColor,
                        }}
                      >
                        {HimTableItem?.priority}
                        {/* Badge Content Here */}
                      </Badge>
                    </td>
                    <td className="workflow-him-table-td">
                      {/* <Badge
                        className="workflow-him-status"
                        ref={(el) => {
                          if (el) {
                            el.style.setProperty(
                              "background-color",
                              "#FFFF",
                              "important"
                            );
                            el.style.setProperty(
                              "border",
                              "1px solid #D0D5DD",
                              "important"
                            );
                            el.style.setProperty(
                              "color",
                              "#344054",
                              "important"
                            );
                          }
                        }}
                      >
                        <span
                          style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            backgroundColor:
                              HimTableItem.status === "in_progress"
                                ? "#316BFF"
                                : HimTableItem.status === "unassigned"
                                ? "#E5E7EB"
                                : HimTableItem.status === "overdue"
                                ? "#F26724"
                                : HimTableItem.status === "uncoded"
                                ? "#478754"
                                : "#4b5563",
                            marginRight: "5px",
                            // dis
                          }}
                        ></span>
                        <span>
                          {HimTableItem.status === "in_progress"
                            ? "In Progess"
                            : HimTableItem.status === "unassigned"
                            ? "Unassigned"
                            : HimTableItem.status === "overdue"
                            ? "Overdue"
                            : HimTableItem.status === "uncoded"
                            ? "Uncoded"
                            : HimTableItem.status}
                        </span>
                      </Badge> */}
                      <Badge
                        ref={(badge) => {
                          if (badge) {
                            // badge.style.setProperty(
                            //   "background-color",
                            //   episode?.status_color,
                            //   "important"
                            // );
                            badge.style.setProperty(
                              "background-color",
                              "#FFFF",
                              "important"
                            );
                            badge.style.setProperty(
                              "border",
                              "1px solid #D0D5DD",
                              "important"
                            );
                            badge.style.setProperty(
                              "color",
                              "#344054",
                              "important"
                            );
                            badge.style.setProperty("display", "flex");
                            // {episode.status === "AI processing complete - codes available for validation" ?  badge.style.setProperty("color", "white") : badge.style.setProperty("color", "#344054")}
                            badge.style.setProperty("align-items", "center");
                            badge.style.setProperty(
                              "justify-content",
                              "center"
                            );
                            badge.style.setProperty("height", "30px");
                            badge.style.setProperty("width", "100%");
                            // badge.style.setProperty("padding", "0px 20px");
                            badge.style.setProperty("font-size", "12px");
                            badge.style.setProperty("white-space", "normal"); // Allow text to wrap
                            badge.style.setProperty("overflow", "hidden"); // Hide overflowed text
                            badge.style.setProperty(
                              "text-overflow",
                              "ellipsis"
                            ); // Add ellipsis if text overflows
                          }
                        }}
                      >
                        {HimTableItem?.status || "-"}
                      </Badge>
                    </td>
                    {/* <td
                      className={`workflow-him-table-td ${
                        selectedHimEpisodes.includes(HimTableItem.medical_record_number)
                          ? "workflow-him-table-td-show"
                          : ""
                      }`}
                    >
                      {selectedHimEpisodes?.includes(
                        HimTableItem.medical_record_number
                      ) && (
                        <Badge
                          className="workflow-him-table-td-assgine-btn"
                          onClick={() => {
                            setWorkflowHimsAssginModal(true);
                            setSelectedRecord(HimTableItem);
                          }}
                        >
                          Assgin
                        </Badge>
                      )}
                    </td> */}
                  </tr>
                ))
              ) : (
                <td colspan="10">
                  <div className="workflow-coder-table-no-records">
                    No records found
                  </div>
                </td>
              )}
            </tbody>
          </Table>
         </div>
          <div className="coderViewTable-footer">
            <div>
              <Pagination className="HimTable-pagination">
                <Pagination.First
                  onClick={() => handlePageChange(1)}
                  disabled={filtersPayload?.page_number <= 1}
                />
                <Pagination.Prev
                  onClick={() =>
                    handlePageChange(filtersPayload?.page_number - 1)
                  }
                  disabled={filtersPayload?.page_number <= 1}
                  className="HimTable-prev-btn"
                />
                <Pagination.Item>
                  Page {filtersPayload?.page_number} of {totalPages}
                </Pagination.Item>
                <Pagination.Next
                  onClick={() =>
                    handlePageChange(filtersPayload?.page_number + 1)
                  }
                  disabled={filtersPayload?.page_number >= totalPages}
                  className="HimTable-next-btn"
                />
                <Pagination.Last
                  onClick={() => handlePageChange(totalPages)}
                  disabled={filtersPayload?.page_number === totalPages}
                />
              </Pagination>
            </div>
          </div>
        </div>
      </div>
      {preferencesLoading ? (
        <div
          className="modal fade coding-screen-popup user-preference-modal show"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body text-center py-5">
                <p className="mt-3">Loading preferences...</p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        showUserPreferenceModal && (
          <div
            className="modal fade coding-screen-popup user-preference-modal show"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={() => setShowUserPreferenceModal(false)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  Kindly select your desired coding module
                </div>
                <div className="modal-footer mb-3">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => navigateToDesiredPage("assist")}
                  >
                    Code Assist
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => navigateToDesiredPage("accelerate")}
                  >
                    Code Accelerate
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      )}
      {workflowHimsAssginModal && (
        <HealthInformationManagerAssignModal
          workflowHimsAssginModal={workflowHimsAssginModal}
          setWorkflowHimsAssginModal={setWorkflowHimsAssginModal}
          selectedRecord={selectedRecord}
          isAllEpisodesSelected={isAllEpisodesSelected}
        />
      )}
    </div>
  );
};

export default CoderView;
